module.exports = __webpack_public_path__ + "img/screen1.213f969d.jpeg";